// extracted by mini-css-extract-plugin
export default {"more":"PlacePhotosPage_more__LHV-t"};